import { render } from "./Page21.vue?vue&type=template&id=e2e19a80"
import script from "./Page21.vue?vue&type=script&lang=js"
export * from "./Page21.vue?vue&type=script&lang=js"

import "./Page21.vue?vue&type=style&index=0&id=e2e19a80&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__